import type { CustomerItem } from "../../../../../mocks/customers";
import PhoneActionMenu from "../../../../../components/contact/PhoneActionMenu";

interface Props {
  customer: CustomerItem;
  toplamHisse: number;
  toplamBorc: number;
  toplamOdenen: number;
  hasLoginAccount?: boolean;
  onEditClick: () => void;
}

const fmt = (n: number) =>
  n.toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  });

export default function CustomerInfoCard({
  customer,
  toplamHisse,
  toplamBorc,
  toplamOdenen,
  hasLoginAccount = false,
  onEditClick,
}: Props) {
  const kalan = toplamBorc - toplamOdenen;

  return (
    <div className="bg-farm-warm border border-farm-border rounded-farm overflow-hidden mb-4">
      <div className="flex items-center justify-between px-4 py-3 bg-farm-cream border-b border-farm-border">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-farm-earth-pale text-farm-earth flex-shrink-0">
            <i className="ri-user-3-line text-sm" />
          </div>
          <div>
            <p className="font-heading font-bold text-sm text-farm-brown leading-tight">
              {customer.adSoyad}
            </p>
            <PhoneActionMenu
              phone={customer.telefon}
              buttonClassName="font-body text-xs font-bold text-farm-earth hover:text-farm-brown"
            />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onEditClick}
            className="flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-farm-cream border border-farm-border text-farm-muted font-body text-[10px] font-semibold hover:border-farm-earth hover:text-farm-earth transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-pencil-line text-xs" />
            </div>
            Düzenle
          </button>
        </div>
      </div>

      <div className="px-4 py-3">
        {customer.kisaNot && (
          <div className="flex items-start gap-1.5 mb-3 px-2.5 py-2 bg-farm-gold-pale/50 border border-farm-gold/20 rounded-md">
            <div className="w-3.5 h-3.5 flex items-center justify-center text-farm-gold mt-0.5 flex-shrink-0">
              <i className="ri-sticky-note-line text-xs" />
            </div>
            <p className="font-body text-xs text-farm-muted italic">{customer.kisaNot}</p>
          </div>
        )}

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3">
          {[
            { label: "Toplam Hisse", value: String(toplamHisse), color: "text-farm-brown" },
            { label: "Toplam Borç", value: toplamBorc > 0 ? fmt(toplamBorc) : "—", color: "text-farm-brown" },
            { label: "Ödenen", value: toplamOdenen > 0 ? fmt(toplamOdenen) : "—", color: "text-farm-green" },
            { label: "Kalan", value: kalan > 0 ? fmt(kalan) : "—", color: kalan > 0 ? "text-farm-earth" : "text-farm-muted" },
          ].map((item) => (
            <div key={item.label} className="bg-farm-cream rounded px-2.5 py-2">
              <p className="font-body text-[10px] text-farm-muted mb-0.5">{item.label}</p>
              <p className={`font-body text-xs font-bold ${item.color}`}>{item.value}</p>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 flex-wrap pt-1 border-t border-farm-border/50">
          <div className="flex items-center gap-1.5">
            <div className="w-3.5 h-3.5 flex items-center justify-center text-farm-muted">
              <i className="ri-shield-user-line text-xs" />
            </div>
            <span className="font-body text-[10px] text-farm-muted">Kullanıcı Hesabı:</span>
            <span className={`font-body text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${hasLoginAccount ? "text-farm-green bg-farm-green-pale" : "text-farm-muted bg-farm-border/50"}`}>
              {hasLoginAccount ? "Var" : "Yok"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
